/**
 * Maps a Stripe card brand to its Font Awesome icon class.
 *
 * Stripe surfaces the brand differently depending on which API returned the card:
 * the modern PaymentMethods API yields lowercase (e.g. "visa"), while the legacy
 * Card API yields capitalized/spaced values (e.g. "American Express"). Normalize
 * before matching so the icon resolves regardless of source. Unknown brands fall
 * back to the generic credit-card icon.
 */
export function cardBrandIcon(brand: string | null | undefined): string {
    switch ((brand || "").toLowerCase().replace(/[\s_]/g, "")) {
        case "visa": return "fab fa-cc-visa";
        case "mastercard": return "fab fa-cc-mastercard";
        case "amex":
        case "americanexpress": return "fab fa-cc-amex";
        case "discover": return "fab fa-cc-discover";
        case "diners":
        case "dinersclub": return "fab fa-cc-diners-club";
        case "jcb": return "fab fa-cc-jcb";
        default: return "fas fa-credit-card";
    }
}
